/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2025.
 */

import { SxProps, Theme } from '@mui/material';

export const skipToMainContentLinkSX: SxProps<Theme> = (theme) => ({
	position: 'absolute',
	left: '-9999px',
	top: 5,
	p: 1,
	zIndex: theme.zIndex.tooltip + 1,
	'&:focus': {
		left: 5,
		transform: 'translateX(5)',
	},
});
